<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PM/PMRoutePlan'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-edit"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="label mb-1">คำค้นหา:</label>
                  <input
                    id="pmrSearch"
                    name="pmrSearch"
                    v-model="pmrSearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจากชื่อตัวแทนจำหน่าย หรือชื่อร้านค้า"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="label mb-1">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="pmrStartDate"
                      name="pmrStartDate"
                      ref="pmrStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="label mb-1">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="pmrEndDate"
                      name="pmrEndDate"
                      ref="pmrEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row"> 
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="label mb-1">ประเภท:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrTypeCode'"
                    :name="'pmrTypeCode'"
                    :select2-options="pmrTypeCodeOptions"
                    v-model="pmrTypeCode"
                  ></select2>
                </div>
              </div> 
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrAgentCodes'"
                    :name="'pmrAgentCodes'"
                    :select2-options="pmrAgentCodesOptions"
                    v-model="pmrAgentCodes"
                    ref="pmrAgentCodesSelect2"
                    multiple
                  ></select2> -->
                  <treeselect v-model="pmrAgentCodes" :multiple="true" :options="pmrAgentCodesOptions" :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div> 
              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'AGENT_ADMIN_PM'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ร้านค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrShopCodes'"
                    :name="'pmrShopCodes'"
                    :select2-options="pmrShopCodesOptions"
                    v-model="pmrShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
                  >
                    *ควรเลือกตัวแทนจำหน่ายด้วย
                  </p>
                </div>
              </div> 

               <!-------ตัวแทนย่อย---->
            <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-show="this.$root.canShow(['super_admin','ADMIN_PM', 'SUB_AGENT_ADMIN_PM'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrSubAgentShopCodes'"
                    :name="'pmrSubAgentShopCodes'"
                    :select2-options="pmrSubAgentShopCodesOptions"
                    v-model="pmrSubAgentShopCodes"
                    ref="pmrShopCodesSelect2"
                    multiple
                  ></select2>
                  <p
                    class="text-danger"
                    v-show="this.$root.canShow(['super_admin', 'ADMIN_PM'])"
                  >
                    *ควรเลือกตัวแทนจำหน่ายย่อยด้วย
                  </p>
                </div>
              </div>
            <!-------สิ้นสุดตัวแทนย่อย-->

            </div>
            <div class="row"> 
           
            </div>
            <div class="row"> 

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label mb-1">ชื่อรูท:</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="ชื่อรูท"
                    id="pmrRouteName"
                    name="pmrRouteName"
                    ref="pmrRouteName"
                    v-model="pmrRouteName"
                  />
                  <span class="form-text"></span>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label mb-1">ผู้ดำเนินการ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrPmUserId'"
                    :name="'pmrPmUserId'"
                    :select2-options="pmrPmUserIdOptions"
                    v-model="pmrPmUserId"
                    multiple
                    ref="pmrPmUserIdSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label mb-1">สถานะ :</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'pmrInActiveStatus'"
                    :name="'pmrInActiveStatus'"
                    :select2-options="pmrInActiveStatusOptions"
                    v-model="pmrInActiveStatus"
                    ref="pmrInActiveStatusSelect2"
                  ></select2>
                </div>
              </div>
            </div>
              
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportRoutePlan"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <router-link
                  to="PMRoutePlan/Add"
                  tag="button"
                  title="เพิ่มข้อมูล"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow([
                      'ADMIN_PM',
                      'AGENT_ADMIN_PM',
                      'COOL_SERVICE_PM','SUB_AGENT_ADMIN_PM'
                    ])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูล
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="routePlanTable"
              >
                <thead>
                  <tr>
                    <th class="all">ประเภท</th>
                    <th class="all">ตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all">ประเภทตัวแทนจำหน่าย</th>
                    <th class="all">วันที่</th>
                    <th class="all">ชื่อรูท</th>
                    <th class="all">ชื่อร้านค้า</th>
                    <th class="all">ชื่อร้านค้า 2</th>
                    <th class="all">ชื่อ-สกุล ผู้ดำเนินการ</th>
                    <th class="all">ชื่อ-สกุล ผู้สร้าง</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import select2 from "../../Shared/Select2";
import router from "../../router";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let RoutePlanActions = Vue.extend({
  template: `
  <div> 
    <a href="#" @click.prevent="editRoutePlan" v-if="data.showEditButton && data.checkEdit" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="deleteRoutePlan" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash"></i>
    </a>
    <a href="#" @click.prevent="copyRoutePlan" title="คัดลอก" class="btn btn-sm btn-clean btn-icon btn-icon-md text-warning">
      <i class="la la-copy"></i>
    </a>
    <a href="#" @click.prevent="unlockShopSurvey" v-if="data.lockedShopSurveyStatus" title="ล็อค Survey PM" class="btn btn-sm btn-clean btn-icon btn-icon-md text-warning">
      <i class="fa fa-unlock text-danger"></i> 
    </a>
    <a href="#" @click.prevent="unlockShopSurvey" v-if="!data.lockedShopSurveyStatus" title="ปลดล็อค Survey PM" class="btn btn-sm btn-clean btn-icon btn-icon-md text-warning">
      <i class="fa fa-lock text-success"></i> 
    </a>
  </div>`,
  methods: {
    copyRoutePlan: function() {
        let self = this;
        
      axios
      .get( "/Api/PM/RoutePlan/" +
                this.data.pmRoutePlanId +
                "/" +
                this.data.pmRoutePlanShopId +
                "/ValidateCopy")
      .then(function(response) {
        if (response.status == 200) {
          self.eShActive = response.data.filter(o => o.statusGroup == "STATUS_SHOP_ACTIVE");
          self.eShInActive = response.data.filter(o => o.statusGroup == "STATUS_SHOP_INACTIVE");
        }
      })

    
      Swal.fire({
        title: 'คำสั่งคัดลอก Route Plan/Adhoc "' + this.data.routeName + '"',
        type: "warning",
        html:
          "<div class='form-group'><label>กรุณาเลือกวันที่ Route Plan/Adhoc</label><div class='input-group date'><input id='swalRouteDatePicker' readonly type='text' class='form-control'><div class='input-group-append'><span class='input-group-text'><i class='la la-calendar-check-o'></i></span></div></div>",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        onOpen: function() {
          var arrows;
          if (KTUtil.isRTL()) {
            arrows = {
              leftArrow: '<i class="la la-angle-right"></i>',
              rightArrow: '<i class="la la-angle-left"></i>',
            };
          } else {
            arrows = {
              leftArrow: '<i class="la la-angle-left"></i>',
              rightArrow: '<i class="la la-angle-right"></i>',
            };
          }

          let datepicker = $("#swalRouteDatePicker").datepicker({
            autoclose: true,
            clearBtn: true,
            format: "dd/mm/yyyy",
            rtl: KTUtil.isRTL(),
            orientation: "bottom left",
            todayBtn: "linked",
            todayHighlight: true,
            templates: arrows,
          });

          if (self.data.typeCode == "PM_TYPE_ADHOC") {
            datepicker.datepicker(
              "setStartDate",
              new Date(moment().format("YYYY/MM/DD"))
            );
            datepicker.datepicker(
              "setEndDate",
              new Date(moment().format("YYYY/MM/DD"))
            );
            datepicker.datepicker("update", moment().format("DD/MM/YYYY"));
          } else {
            datepicker.datepicker(
              "setStartDate",
              new Date(
                moment()
                  .add(1, "days")
                  .format("YYYY/MM/DD")
              )
            );
            datepicker.datepicker(
              "update",
              moment()
                .add(1, "days")
                .format("DD/MM/YYYY")
            );
          }
        },
      }).then((result) => {
        if (result.value) {
          var date = $("#swalRouteDatePicker").val();
          if (!date) {
            Swal.fire({
              title:
                'คำสั่งคัดลอก Route Plan/Adhoc "' + this.data.routeName + '"',
              type: "error",
              text: "กรุณาเลือกวันที่",
            }).then(() => {
              self.copyRoutePlan();
            });
            return;
          }

          KTApp.blockPage({
            opacity: 0.05,
            message: "คำสั่งคัดลอก กรุณารอสักครู่...",
          });
          axios
            .post(
              "/Api/PM/RoutePlan/" +
                this.data.pmRoutePlanId +
                "/" +
                this.data.pmRoutePlanShopId +
                "/Copy",
              {
                routePlanDate: date,
              }
            )
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    editRoutePlan: function() {
      router.push({
        path: `/PM/PMRoutePlan/Edit/${this.data.pmRoutePlanId}`,
      });
    },
    deleteRoutePlan: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งลบ Route Plan/Adhoc",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบข้อมูล Route Plan/Adhoc <strong>" +
          "</strong> หลังจากลบแล้วจะส่งผลให้ Route Plan/Adhoc นี้ไม่ถูกใช้งาน",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบข้อมูลการ Route Plan/Adhoc ออกจากข้อมูล",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่...",
          });
          axios
            .put(
              "/Api/PM/RoutePlan/" +
                this.data.pmRoutePlanId +
                "/" +
                this.data.pmRoutePlanShopId +
                "/Delete"
            )
            .then(function(response) {
              //console.log(response);
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    unlockShopSurvey: function() {
      let self = this;
      var title_html =  `กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะการทำ Survey PM 	<br/>ชื่อรูท : ${this.data.routeName}	<br/> ชื่อร้านค้า : ${this.data.shopName}<strong>`;
      if(this.data.lockedShopSurveyStatus==true){
        title_html =  `กรุณายืนยันคำสั่งเปิดการตรวจสอบสถานะการทำ Survey PM 	<br/>ชื่อรูท : ${this.data.routeName}	<br/> ชื่อร้านค้า : ${this.data.shopName}<strong>`;
      } 

      if(!self.$root.canShow(["super_admin"])){
        Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดำเนินการได้ กรุณาติดต่อผู้ดูแลระบบ", "error");
      }
      else{ 
        Swal.fire({
            title: "กรุณายืนยันคำสั่งปิดการตรวจสอบสถานะการทำ Survey PM  ",
            type: "warning",
            html:title_html,
            input: this.data.userCount > 0 ? "checkbox" : "",
            inputValue: 0,
          // inputPlaceholder: "ต้องการลบข้อมูลการ Route Plan/Adhoc ออกจากข้อมูล",
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
          }).then((result) => {
            if (result.value) {
              KTApp.blockPage({
                opacity: 0.05,
                message: "กำลังลบข้อมูล กรุณารอสักครู่...",
              });
              axios
                .put(
                  "/Api/PM/RoutePlan/" +
                    this.data.pmRoutePlanId +
                    "/" +
                    this.data.pmRoutePlanShopId +
                    "/IgnorValidateSurvey"
                )
                .then(function(response) {
                  //console.log(response);
                  if (response.data.data) {
                    self.$parent.reloadDataTable();
                    Swal.fire("สำเร็จ", response.data.message, "success");
                  } else {
                    Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                  }
                })
                .catch(function(error) {
                  Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
                })
                .then(function() {
                  // always executed
                  KTApp.unblockPage();
                });
            }
          });

        }//end if

    },
  },
});

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/PM/RoutePlan/" + this.data.pmRoutePlanId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#userTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไขข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put("/Api/PM/RoutePlan/" + this.data.pmRoutePlanId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      pmrSearch: null,
      pmrTypeCode: null,
      pmrStartDate: null,
      pmrEndDate: null,
      pmrAgentCodes: [],
      pmrShopCodes: [],
      pmrInActiveStatus: null,
      pmrRouteName: null,
      pmrPmUserId: [],

      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [],
      pmrSubAgentShopCodes : [],
      pmrSubAgentShopCodesOptions : [],


      // Configurations
      pmrInActiveStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null },
        ],
      },
      pmrTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      pmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      pmrAgentCodesOptions: [],
      // pmrAgentCodesOptions: {
      //   placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
      //   allowClear: true,
      //   ajax: {
      //     url: self.$root.canShow(["AGENT_ADMIN_PM"])
      //       ? "/Api/Agents/AgentOptions"
      //       : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
      //     type: "post",
      //     delay: 300,
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //         province_id: [],
      //         department: [],
      //         agentCodes: [],
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      pmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },

      
      pmrSubAgentShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         //pmrSubAgentCodes
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.pmrAgentCodes, 
              shopCodes  : self.pmrSubAgentCodes,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.pmrAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 


    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.pmrSearch = null;
      self.pmrStartDate = null;
      self.pmrEndDate = null;
      self.pmrTypeCode = null;
      self.pmrAgentCodes = [];
      self.pmrShopCodes = [];
      self.pmrInActiveStatus = false;
      self.pmrRouteName = null;
      self.pmrPmUserId = []; 
      self.pmrSubAgentCodes  = []; 
      self.pmrSubAgentShopCodes = []; 

      $("#pmrStartDate")
        .val("")
        .trigger("change");

      $("#pmrEndDate")
        .val("")
        .trigger("change");

      $("#pmrTypeCode")
        .val("")
        .trigger("change");

      $("#pmrAgentCodes")
        .val("")
        .trigger("change");

      $("#pmrShopCodes")
        .val("")
        .trigger("change");

      $("#pmrPmUserId")
        .val("")
        .trigger("change");

      $("#pmrInActiveStatus")
        .val(self.pmrInActiveStatus + "")
        .trigger("change");

        $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

      $("#pmrSubAgentShopCodes")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#routePlanTable").DataTable();
      table.search();
      table.draw();
    },
    exportRoutePlan: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/PM/RoutePlan/ExportRoutePlan",
        responseType: "arraybuffer",
        data: {
          SearchKeyword: self.pmrSearch,
          StartDate: self.pmrStartDate != null
              ? self.pmrStartDate.format("DD/MM/YYYY")
              : self.pmrStartDate,
          EndDate: self.pmrEndDate != null
              ? self.pmrEndDate.format("DD/MM/YYYY")
              : self.pmrEndDate,
          TypeCode: self.pmrTypeCode,
          AgentCodes: self.pmrAgentCodes,
          ShopCodes: self.pmrShopCodes,
          SubAgentCodes: self.pmrSubAgentCodes,
          SubAgentShopCodes: self.pmrSubAgentShopCodes,
          RouteName: self.pmrRouteName,
          PmUserId: self.pmrPmUserId,
          ActiveStatus: self.pmrInActiveStatus,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    reloadDataTable: function(resetPaging = false) {
      $("#routePlanTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    LoadpmrAgentCodesOptions: function(e) {
      var self = this;
      axios
        .post(
          self.$root.canShow(["AGENT_ADMIN_PM"])
            ? "/Api/Agents/AgentOptions"
            : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          {
            province_id: [],
            department: [],
            agentCodes: [],
            page: 1,
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.pmrAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
  },
  async mounted() {
    let self = this;

    self.LoadpmrAgentCodesOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    let today = moment();
    let lastDayOfYear = moment().endOf("year");
    self.pmrStartDate = today;
    self.pmrEndDate = lastDayOfYear;

    $(self.$refs.pmrStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.pmrStartDate)
      .datepicker(
        "update",
        !!self.pmrStartDate ? self.pmrStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.pmrStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.pmrEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.pmrEndDate)
      .datepicker(
        "update",
        !!self.pmrEndDate ? self.pmrEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.pmrEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    //default Active Data
    self.pmrInActiveStatus = false;
    $("#pmrInActiveStatus")
      .val(self.pmrInActiveStatus + "")
      .trigger("change");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#routePlanTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/PM/RoutePlan/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.pmrSearch,
                StartDate:
                  self.pmrStartDate != null
                    ? self.pmrStartDate.format("DD/MM/YYYY")
                    : self.pmrStartDate,
                EndDate:
                  self.pmrEndDate != null
                    ? self.pmrEndDate.format("DD/MM/YYYY")
                    : self.pmrEndDate,
                TypeCode: self.pmrTypeCode,
                AgentCodes: self.pmrAgentCodes,
                ShopCodes: self.pmrShopCodes,
                SubAgentCodes: self.pmrSubAgentCodes,
                SubAgentShopCodes: self.pmrSubAgentShopCodes,
                RouteName: self.pmrRouteName,
                PmUserId: self.pmrPmUserId,
                ActiveStatus: self.pmrInActiveStatus,
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[3, "desc"]],
        columns: [
          {
            data: "typeCode",
            className: "text-center",
            width: "10%",
            render: function(data, type, full, meta) {
              return full.typeName;
            },
          },
          {
            data:   "agentName" ,
            className: "text-center",
            width: "15%", 
            render: function(data, type, full, meta) {
              if(full.agentTypeCode == "SUB_AGENT"){
                return full.subAgentName ;
              }
              else{
                return full.agentName ;
              }
              
            },
          },
          {
            data: "agentTypeCode",
            className: "text-center",
            width: "10%",
            render: function(data, type, full, meta) {
              return full.agentTypeName;
            },
          },
          {
            data: "routePlanDate",
            className: "text-center",
            width: "10%",
            render: function(data, type, full, meta) {
              return full.routePlanDateFormat;
            },
          },
          {
            data: "routeName",
            className: "text-center",
            orderable: false,
            width: "10%",
          },
          {
            data: "shopName",
            className: "text-center",
            orderable: false,
            width: "20%",
            render: function(data, type, full, meta) {
              if(full.agentTypeCode == "SUB_AGENT"){
                return full.subAgentShopName ;
              }
              else{
                return full.shopName ;
              }
              
            },
          },
          {
            data: "shopName2",
            className: "text-center",
            orderable: false,
            width: "20%",
            render: function(data, type, full, meta) {
              if(full.agentTypeCode == "SUB_AGENT"){
                return full.subAgentShopName2 ;
              }
              else{
                return full.shopName2 ;
              }
              
            },
          },
          {
            data: "pmUserName",
            className: "text-center",
            orderable: false,
            width: "10%",
          },
          {
            data: "createByUserFullName",
            className: "text-center",
            width: "10%",
          },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            },
          },
          {
            data: "pmRoutePlanShopId",
            className: "text-center",
            width: "5%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "ADMIN_PM",
              "AGENT_ADMIN_PM",
              "SUB_AGENT_ADMIN_PM",
              "COOL_SERVICE_PM",
            ]);

            var routePlanDate = new Date(data.routePlanDate);
            data.showDeleteButton =
              self.$root.canShow([
                "ADMIN_PM",
                "AGENT_ADMIN_PM",
                "SUB_AGENT_ADMIN_PM",
                "COOL_SERVICE_PM",
              ]) && routePlanDate > new Date();

            if (data.typeCode == "PM_TYPE_ROUTE_PLAN") {
              data.checkEdit = routePlanDate > new Date() ? true : false;
            } else if (data.typeCode == "PM_TYPE_ADHOC") {
              data.checkEdit = !data.isCheckIn;
            }

            new RoutePlanActions({ data: { data }, parent: self }).$mount(el);
          }
        });
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "ADMIN_PM",
              "AGENT_ADMIN_PM",
              "SUB_AGENT_ADMIN_PM",
              "COOL_SERVICE_PM",
            ]);
            if (data.inActiveStatus == 0)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == 1)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/PM/SearchPMRoutePlan.vue